import { emitterCreateDispatcher } from '@THC/utils/emitter';

import { OTPModalEmitter } from './OTPModalEmitter';

const dispatchEvent = emitterCreateDispatcher(OTPModalEmitter);

export const otpModalShow = dispatchEvent('show');
export const otpModalHide = dispatchEvent('hide');
